class ShuffledProducts extends HTMLElement {
  connectedCallback() {
    if (this.dataset.shuffled === 'true') return;

    const list = this.querySelector('ul');
    if (!list || list.children.length < 2) return;

    this.dataset.shuffled = 'true';

    const items = Array.from(list.children);
    for (let i = items.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [items[i], items[j]] = [items[j], items[i]];
    }

    list.append(...items);
    list.scrollLeft = 0;
  }
}

customElements.define('shuffled-products', ShuffledProducts);
